import { ReactTFC } from "../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";
import React from "react";
import { CSS_MQ } from "../../styles/breakpoints";
import { GeneralTranslation } from "@swo/storefront";
import { DealerPageData, ExtractSwarovskiPageData } from "@swo/storefront";
import { DealerDetailsVisual } from "./dealer-details-visual";
import { DealerDetailsInfo } from "./dealer-details-info";
import { DealerDetailsContact } from "./dealer-details-contact";

export const DealerDetailsComponent: ReactTFC<{
  dealerDetails: ExtractSwarovskiPageData<DealerPageData>["data"]["dealerDetails"];
  translations: ExtractSwarovskiPageData<DealerPageData>["data"]["translations"];
  generalTranslations: GeneralTranslation;
  dealerLocatorLink: string;
  apiKey: string;
}> = props => {
  function getState() {
    if (props.dealerDetails?.address?.coordinates && props.dealerDetails.imageUrl) {
      return "both-visuals";
    } else if (
      (props.dealerDetails.address?.coordinates && !props.dealerDetails.imageUrl) ||
      (!props.dealerDetails.address?.coordinates && props.dealerDetails.imageUrl)
    ) {
      return "single-visual";
    } else {
      return "none";
    }
  }

  const state = getState();

  return (
    <React.Fragment>
      <div className={state} css={wrapperStyles}>
        <DealerDetailsVisual
          coordinates={props.dealerDetails.address?.coordinates}
          name={props.dealerDetails.name}
          imageUrl={props.dealerDetails.imageUrl}
          dealerId={props.dealerDetails.id}
          apiKey={props.apiKey}
        />

        <div
          css={css`
            grid-area: dealer-headline;
          `}
        >
          <DealerDetailsInfo
            dealerDetails={props.dealerDetails}
            translations={props.translations}
            generalTranslations={props.generalTranslations}
            dealerLocatorLink={props.dealerLocatorLink}
          />
        </div>

        <DealerDetailsContact
          dealerDetails={props.dealerDetails}
          translations={props.translations}
          dealerLocatorLink={props.dealerLocatorLink}
          navigateLabel={props.translations.navigateLabel.value}
        />
      </div>
    </React.Fragment>
  );
};

const wrapperStyles = css`
  display: grid;

  grid-template-columns: 1fr;
  grid-template-areas:
    "main-visual"
    "dealer-headline"
    "contact"
    "opening-hours"
    "additional-visual";

  ${CSS_MQ.atLeastLg} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: auto auto auto;

    &.both-visuals {
      grid-template-areas:
        "main-visual additional-visual"
        "dealer-headline contact"
        "dealer-headline opening-hours";
    }
    &.single-visual {
      grid-template-areas:
        "main-visual main-visual"
        "dealer-headline contact"
        "dealer-headline opening-hours";
    }
  }

  &.both-visuals {
    --aspect-ratio: ${2 / 3};
    ${CSS_MQ.atLeastLg} {
      --aspect-ratio: 1;
    }
  }

  &.single-visual {
    --aspect-ratio: ${2 / 3};
    ${CSS_MQ.atLeastLg} {
      --aspect-ratio: ${1 / 2};
    }
  }
`;
